<div class="start-center flex-row">
    <button mat-icon-button (click)="sidenav.toggle()">
        <mat-icon>menu</mat-icon>
    </button>
    <h1 class="app-name" (click)="goToHome()">ClassicHub</h1>
    <cb-env-display></cb-env-display>
    <span class="flex"></span>
    @if (buttons && buttons.length) {
        @for (button of buttons; track button) {
            <button class="button-place-holder" color="white" (click)="button.onClick()">
                {{ button.element.innerText }}
            </button>
        }
    }
    <button
        mat-icon-button
        (click)="openNotifications($event)"
        id="notification-button"
        class="cb-notification-icon"
        aria-label="Open Notifications"
    >
        @if (unreadNotificationsCount > 0) {
            <div class="count-wrapper-outer">
                <div class="count-wrapper-inner">
                    <div class="count-text">{{ unreadNotificationsCount }}</div>
                </div>
            </div>
        }
        @if (!notificationsOpen) {
            <mat-icon>chat</mat-icon>
        }
        @if (notificationsOpen) {
            <mat-icon>close</mat-icon>
        }
    </button>
    <div id="logo-container">
        <div class="cbhub-logo-curve"></div>
        <div class="logo"></div>
    </div>
</div>
